<script setup lang="ts">
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
// Imported for its side effect: keeps data-theme in sync with the stored preference.
import '@/lib/theme';

const auth = useAuthStore();

onMounted(async () => {
  await auth.bootstrap();
});
</script>

<template>
  <RouterView />
</template>
